import {
  Button,
  ModalActions,
  ModalContent,
  ModalHeader,
  Text,
} from '@lightspeed/design-system-react'
import React, { FC } from 'react'
import { useT } from '@transifex/react'
import { useVdCurrencyFilter } from '../../../../../../ng-compat/hooks'

interface Props {
  approvedAmount?: number
  onAccept: () => void
  onReverse: () => void
}

export const PartialApprove: FC<Props> = ({
  approvedAmount,
  onAccept,
  onReverse,
}) => {
  const t = useT()
  const currencyFilter = useVdCurrencyFilter()
  const modalHeader = approvedAmount
    ? t('Only {approvedAmount} of this payment has been approved.', {
        approvedAmount: currencyFilter(approvedAmount),
        _context:
          'The payment prompt header indicates that only a portion of the payment, has been approved',
      })
    : t('Only part of this payment has been approved.', {
        _context:
          'The payment prompt header indicates that only a portion of the payment, has been approved',
      })
  return (
    <>
      <ModalHeader>{modalHeader}</ModalHeader>
      <ModalContent>
        <Text tag="p" className="vd-no-widow">
          {t(
            'Continue to take payment for the remaining balance, or refund this amount to take payment another way of discard the sale.',
            {
              _context:
                'The payment prompt shows that, the remaining balance can be charged, refund already charged amount, or discard the sale.',
            }
          )}
        </Text>
      </ModalContent>
      <ModalActions>
        <div className="vd-btn-group">
          <Button
            data-track="refund-partial-payment-partial-approve"
            variant="supplementary"
            onClick={onReverse}
          >
            {t('Refund Partial Payment', {
              _context: 'Button label for partial refunding',
            })}
          </Button>
          <Button
            data-track="continue-partial-approve"
            variant="go"
            onClick={onAccept}
          >
            {t('Continue', { _context: 'Button label for continuing' })}
          </Button>
        </div>
      </ModalActions>
    </>
  )
}
